<template>
  <div id="users">
    <div id="alerts">
      <h1>Manage Users</h1>
      <span v-if="!users.length">No Users</span>
      <div class="alerts">
        <div v-for="user in users" :key="user.id" class="alert">
          <span v-if="user.is_admin" class="bold">Administrator<br /></span>
          {{ user.full_name }}<br />
          {{ user.email }}<br />
          <span v-if="!user.is_admin">
            <span v-if="user.email_verified_date">
              User finished setting up account<br />
            </span>
            <span v-else>
              {{ user.email_verified_date }}
              User did not set up account<br />
              <a href="#" @click.prevent="resendEmail(user)"
                >Resend Password Setup Email</a
              ><br />
            </span>
            <a href="#" @click.prevent="showDeleteUserAlert(user.id)"
              >Delete User</a
            >
          </span>
          <span v-else>&nbsp;</span>
        </div>
      </div>
      <div class="center-text">
        <router-link
          to="/console/account/usercreate"
          tag="button"
          name="addProperty"
          class="button button-200"
          >Create User</router-link
        >
      </div>
      <v-dialog />
    </div>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceUser = new api.APIServiceUser();

export default {
  name: "Users",
  data() {
    return {
      property_id: this.$route.params.id,
      users: []
    };
  },
  // computed: {
  //   users () {
  //     return this.$store.getters.users;
  //   }
  // },
  created() {
    // this.$store.dispatch('getUsers', this.$route.params.id);
    this.getUsers();
  },
  methods: {
    getUsers: function() {
      apiServiceUser.getUsers().then(data => {
        if (data) {
          this.users = data.data;
        }
      });
    },
    showDeleteUserAlert: function(userID) {
      this.$modal.show("dialog", {
        title: "Alert!",
        text: "Do you want to delete this user?",
        buttons: [
          {
            title: "Yes",
            handler: () => {
              this.deleteForReal(userID);
            }
          },
          {
            title: "", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {} // Button click handler
          },
          {
            title: "No"
          }
        ]
      });
    },
    deleteForReal: function(userID) {
      this.hide();
      // this.$store.dispatch('deleteUser', userID);
      apiServiceUser.deleteUser(userID).then(data => {
        this.getUsers();
      });
    },
    hide: function() {
      this.$modal.hide("dialog");
    },
    resendEmail: function(user) {
      apiServiceUser.resendUserPasswordCreateLink(user).then(data => {
        this.showResendEmailAlert(user);
        this.getUsers();
      });
    },
    showResendEmailAlert: function(user) {
      this.$modal.show("dialog", {
        title: "Sent",
        text: "Password create email sent to " + user.full_name,
        buttons: [
          {
            title: "OK",
            handler: () => {
              this.hide();
            }
          },
          {
            title: "", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {
              this.hide();
            } // Button click handler
          }
        ]
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 18px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#alerts {
  lost-utility: clearfix;
}
.alerts {
  width: 100%;
  lost-column: 1/1;
}
.alert {
  lost-column: 1/3;
  background: #d5e3f4;
  padding: 15px;
  border-radius: 4px;
  lost-utility: clearfix;
  margin-bottom: 20px;
}
@media (max-width: 800px) {
  .alert {
    lost-column: 1/2;
  }
}
@media (max-width: 640px) {
  .alert {
    lost-column: 1/1;
  }
}
</style>
